import './FilterOperatorToggler.scss';
import cx from 'classnames';
import { Operator } from '../types';

interface FilterOperatorTogglerProps {
  operator: Operator;
  onToggle: (operator: Operator) => void;
}

const FilterOperatorToggler = ({
  operator,
  onToggle,
}: FilterOperatorTogglerProps) => {
  return (
    <div className="FilterOperatorToggler">
      <button
        className={cx('FilterOperatorToggler__button', {
          'FilterOperatorToggler__button--active': operator === Operator.AND,
        })}
        onClick={() => onToggle(Operator.AND)}
      >
        AND
      </button>
      <button
        className={cx('FilterOperatorToggler__button', {
          'FilterOperatorToggler__button--active': operator === Operator.OR,
        })}
        onClick={() => onToggle(Operator.OR)}
      >
        OR
      </button>
    </div>
  );
};

export default FilterOperatorToggler;
